import './match-height-custom';

((window, $) => {

  $(() => {

    $('.pageTitle').wrapInner('<span />');

    $('.pager').each((index, element) => {
      const $el = $(element);
      $el.addClass(`pager--${index}`);
    });

    const $groupLayout = $('.groupLayout');
    const $groupLayoutItem = $groupLayout.find('.gl_Item');

    $groupLayoutItem.matchHeight();

    $groupLayoutItem.each(function() {
      const $el = $(this);
      const $labelFreeShipping = $el.find('.freeshipping');
      const $labelSale = $el.find('.sale');
      const $labelSoldOut = $el.find('.FS2_noStockText');
      const $copy = $el.find('.itemCatchCopy');

      $el.append($copy);

      $copy.wrapInner('<span />');


      if($labelFreeShipping.length !== 0) {
        $el.addClass('user_is_freeshipping');
      }

      if($labelSale.length !== 0) {
        $el.addClass('user_is_discounted');
      }

      if($labelSoldOut.length !== 0) {
        $el.addClass('user_is_soldout');
      }
    });

    // trim txt
    (() => {
      let trimTxt = function($target, txt, line, $box) {
        let lineheight = parseInt($target.css('line-height'), 10);

        if(lineheight * (line + 0.5) < $box.height()) {
          for(let j = 0; j < txt.length; j++) {
            $target.html(txt.slice(0, -(j+1)) + '...');

            if(lineheight * (line + 0.5) >= $box.height()) {
              break;
            }
          }
        }
      }

      let $item = $('.FS2_body_Goods_GoodsSearchList .gl_Item'),
          txt = [],
          resize_flag;

      $item.each(function(i) {
        let $span = $(this).find('.itemCatchCopy span');

        txt[i] = $span.html();
      });

      $(window).on('resize.line_limit', () => {
        resize_flag = true;
      });

      let trimItexText = function() {
        $item.each(function(i) {
          let $span = $(this).find('.itemCatchCopy span'),
              lineheight = parseInt($span.css('line-height'), 10);

          $span.css('height', 'auto');
          $span.html(txt[i]);

          setTimeout(() => {
            trimTxt($span, txt[i], 2, $span);
          }, 1000 / 60)
        });
      }

      trimItexText();

      setInterval(() => {
        if(resize_flag) {
          resize_flag = false;

          trimItexText();
        }
      }, 1000 / 8)
    })();
  });

})(window, jQuery);



// WEBPACK FOOTER //
// ./src/js/fs/search_result.js